<template>
  <section
    v-loading="loading"
    class="new-case-view case-creation"
    id="single-case-view"
  >
    <div>
      <div class="container-sm">
        <el-row :gutter="20" type="flex">
          <el-col :lg="16">
            <div class="pendingOrderScrollable">
              <section id="view-case-screen ">
                <PatientInformation></PatientInformation>
                <span class="case-creation__divider"></span>
                <CaseInformation></CaseInformation>
                <span class="case-creation__divider"></span>
                <TestInformation></TestInformation>
              </section>
            </div>
          </el-col>
          <el-col :lg="8">
            <div class="pendingOrderSticky">
              <ChatApplication></ChatApplication>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";

const PatientInformation = defineAsyncComponent(() =>
  import("@/components/pendingClientOrders/PatientInformation")
);
const CaseInformation = defineAsyncComponent(() =>
  import("@/components/pendingClientOrders/CaseInformation")
);
const ChatApplication = defineAsyncComponent(() =>
  import("@/components/pendingClientOrders/ChatApplication")
);
const TestInformation = defineAsyncComponent(() =>
  import("@/components/pendingClientOrders/TestInformation")
);
import { mapGetters } from "vuex";

export default {
  components: {
    PatientInformation,
    CaseInformation,
    ChatApplication,
    TestInformation,
  },

  data() {
    return {
      scrollPosition: null,
      description: "",
      loading: false,
      show: false,
      unsetCompleteStatusChangeCase: "",
      takeStatusChangeReasonDialog: false,
      takeStatusChangeReasonDialogTitle: "",
      toStatus: "",
      refreshView: false,
      caseId: "",
      AuditLogsPopup: false,
    };
  },
  computed: {
    ...mapGetters("clientPendingOrders", [
      "getPendingOrderDetails",
      "getPendingOrderLogs",
    ]),
    orderId() {
      return this.$route.params.order_id;
    },
  },
  async mounted() {
    this.show = true;
    // Add Class
    this.toggleBodyClass("addClass", "fixedNavbarBody");
    // Scroll
    window.addEventListener("scroll", this.updateScroll);
    await this.fetchClientPendingOrder();
    await this.fetchOrderLogs();
  },
  async unmounted() {
    // Remove Class
    this.toggleBodyClass("removeClass", "fixedNavbarBody");
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    async fetchClientPendingOrder() {
      try {
        let params = {
          order_id: this.orderId,
        };
        await this.$store.dispatch(
          "clientPendingOrders/fetchPendingOrderDetails",
          params
        );
      } catch (err) {
        console.log(err);
      }
    },
    async fetchOrderLogs() {
      try {
        let params = {
          order_id: this.orderId,
        };
        await this.$store.dispatch(
          "clientPendingOrders/fetchPendingOrderLogs",
          params
        );
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#generate-barcode-button {
  background: linear-gradient(79.26deg, #f24a55 -13.43%, #0a5da6 137.71%);
  color: white;
  border-radius: 7px;
  padding: 6px 20px;
  border: none;
  font-weight: 600;
}
.editCase {
  button {
    display: flex;
    align-items: center;
    cursor: pointer;
    background: none;
    border: none;
    font-size: 15px;
    font-weight: 500;
    color: #ffffff;
    border: 1px solid #f24a55;
    background: #f24a55;
    border-radius: 4px;
    padding: 0 10px;
    img {
      margin-right: 7px;
      margin-bottom: -3px;
      width: 15px;
    }
  }
}
.requisition-d-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
  .leftBlock {
    background: #ffffff;
    padding: 8px 10px;
    border-radius: 6.40567px;
    border: 1.2px solid #e7e7f7;
  }
}
#case-status-button {
  &:hover {
    pointer-events: auto !important;
    cursor: not-allowed !important;
  }
}
</style>
<style lang="scss">
.pendingOrderSticky {
  position: sticky;
  top: 20px;
  background-color: #f1f1f1;
}

.pendingOrderScrollable {
  overflow-y: auto;
  height: calc(100vh - 80px);
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
